// Generated by genversion.
export const version = '23.25.0';
